import md5 = require("blueimp-md5");

export default function (value: string): string {
	const hash = md5(value);
	const rgb = "#" + hash.substring(0, 6);
	return rgb;
}
